import { createSelector } from "reselect";
import { isUninitialized, isCompleted as isCompleted$1, isFailed as isFailed$1 } from "./state.js";
const getCheckout = (state) => state.checkout;
const isInitialized = createSelector(
  getCheckout,
  (checkout) => checkout && !isUninitialized(checkout)
);
const isCompleted = createSelector(
  getCheckout,
  (checkout) => checkout && isCompleted$1(checkout)
);
const isFailed = createSelector(
  getCheckout,
  (checkout) => checkout && isFailed$1(checkout)
);
const getCartState = createSelector(
  getCheckout,
  (checkout) => checkout && !isUninitialized(checkout) && checkout.root ? checkout.root.cartState : void 0
);
const getRoutes = createSelector(
  getCheckout,
  (checkout) => checkout && !isUninitialized(checkout) && checkout.root ? checkout.root.routes : void 0
);
const getSelfUrl = createSelector(
  getCheckout,
  (checkout) => checkout && !isUninitialized(checkout) && checkout.root ? checkout.root.selfUrl : void 0
);
const getError = createSelector(
  getCheckout,
  (checkout) => checkout && isFailed$1(checkout) && checkout.error ? checkout.error : void 0
);
const getMyAccount = createSelector(
  getCheckout,
  (checkout) => checkout && !isUninitialized(checkout) && checkout.myAccount ? checkout.myAccount : void 0
);
const shouldCreateAccount = createSelector(
  getCheckout,
  (checkout) => checkout && !isUninitialized(checkout) && checkout.myAccount ? !!checkout.myAccount.shouldCreateAccount : false
);
const getSelectedDonation = createSelector(
  getCheckout,
  (checkout) => checkout && !isUninitialized(checkout) && checkout.payment.selectedPaymentMethod && checkout.donations ? checkout.donations.find(
    (donation) => donation.paymentMethod === checkout.payment.selectedPaymentMethod?.type
  ) : void 0
);
const getShipping = createSelector(
  getCheckout,
  (checkout) => checkout && !isUninitialized(checkout) && checkout.shipping ? checkout.shipping : void 0
);
const getConsents = createSelector(
  getShipping,
  (shipping) => shipping && shipping.consents ? shipping.consents : void 0
);
const isConsentGiven = createSelector(
  getConsents,
  (consents) => consents && !consents.some((consent) => consent.isChecked === false)
);
const getChangedOptIns = createSelector(
  getMyAccount,
  (myAccount) => myAccount && myAccount.changedOptIns
);
const getServiceStore = createSelector(
  getShipping,
  (shipping) => shipping && (shipping.serviceStore || shipping.serviceStore === null) ? shipping.serviceStore : void 0
);
export {
  getCartState,
  getChangedOptIns,
  getCheckout,
  getConsents,
  getError,
  getMyAccount,
  getRoutes,
  getSelectedDonation,
  getSelfUrl,
  getServiceStore,
  getShipping,
  isCompleted,
  isConsentGiven,
  isFailed,
  isInitialized,
  shouldCreateAccount
};
//# sourceMappingURL=selectors.js.map
